import { render, staticRenderFns } from "./ModelosAutos.vue?vue&type=template&id=a206e6e6&"
import script from "./ModelosAutos.vue?vue&type=script&lang=js&"
export * from "./ModelosAutos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../bym/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports